import { CenterScreen, LoadingContent } from '@ztechapps/webui.util'
import type { PrivateLayoutProps } from './index'
import { PrivateLayout } from './index'
import { useLogoutWhenSignedOut, useUser } from '@ztechapps/common.hook'
import includes from 'lodash/includes'
import { useMemo } from 'react'

export type HasAppAccessPrivateLayoutProps = PrivateLayoutProps & {
  hasAppAccessPermission: string
  // localStorage keys the session was written under — apps whose login flow doesn't use
  // useUser's 'app-login-*' defaults (e.g. owntext-admin's bespoke 'owntext-login-*')
  // MUST pass their own keys here, or this gate reads no user and always logs the session out.
  userIdKey?: string
  tokenKey?: string
}

export const HasAppAccessPrivateLayout = ({
  hasAppAccessPermission,
  header,
  sidebar,
  userIdKey,
  tokenKey,
}: HasAppAccessPrivateLayoutProps) => {
  const { user, isActive, hasTenant, loading, logout } = useUser({ userIdKey, tokenKey })

  const roles = user?.roles
  const userId = user?._id
  const hasAppAccess = includes(roles, hasAppAccessPermission)

  const isAuthenticated = useMemo<boolean | null>(() => {
    if (loading) return null

    return hasAppAccess && hasTenant && isActive && !!userId
  }, [loading, hasAppAccess, isActive, hasTenant, userId])

  useLogoutWhenSignedOut({ loading, isAuthenticated: !!isAuthenticated, logout })

  if (isAuthenticated === null)
    return (
      <CenterScreen>
        <LoadingContent message={`Loading....`} subMessage="Please wait while we are loading the screen..." />
      </CenterScreen>
    )

  if (isAuthenticated === false) return null

  //if the user is authenticated can go here
  return <PrivateLayout header={header} sidebar={sidebar} />
}
